import type { JSONContent } from "@tiptap/react";

import { ExternalComments } from "./ExternalComments";

import { Column } from "@/components";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { commsTabTriggerClassName } from "@/lib/constants";

// Company scope of the comms rail: just Comments today, but shares the
// Internal/Candidate scopes' tab-bar shell so the three scopes line up.
export const ExternalCommsTabs = ({
  commentDraft,
  onCommentDraftChange,
}: {
  commentDraft: JSONContent;
  onCommentDraftChange: (contentJson: JSONContent) => void;
}) => {
  /* Render */
  const render = () => {
    return (
      <Tabs
        className="flex min-h-0 w-full flex-1 flex-col overflow-hidden pt-3"
        value="comments"
      >
        <Column className="w-full px-2 pb-4">
          <TabsList className="flex h-auto w-full justify-start gap-0 rounded-none border-b border-slate-300 bg-transparent p-0 text-slate-500 shadow-none">
            <TabsTrigger className={commsTabTriggerClassName} value="comments">
              Comments
            </TabsTrigger>
          </TabsList>
        </Column>
        <TabsContent
          className="min-h-0 w-full flex-1 overflow-hidden px-3 pb-4"
          value="comments"
        >
          <ExternalComments
            commentDraft={commentDraft}
            onCommentDraftChange={onCommentDraftChange}
          />
        </TabsContent>
      </Tabs>
    );
  };

  return render();
};
